import { environment as base } from './environment.base';

export const environment = {
  ...base,
  code: 'verv',
  dashboard: '',
  b2cPolicySignUp: 'B2C_1_MemberPortal_SignUp',
  b2cPolicySignIn: 'B2C_1_VERVStg_MemberPortal_SignUpSignIn',
  b2cSignInAuthority:
    'https://apexproductdevelopment.b2clogin.com/apexproductdevelopment.onmicrosoft.com/B2C_1_VERVStg_MemberPortal_SignUpSignIn',
  b2cSignUpAuthority:
    'https://apexsmrt.b2clogin.com/apexsmrt.onmicrosoft.com/B2C_1_MemberPortal_SignUp',
  b2cAuthorityDomain: 'apexproductdevelopment.b2clogin.com',
  b2cClientId: 'a24fe80c-adce-41bb-9a85-32e509cc9ef0',
  b2cReadScope:
    'https://ApexProductDevelopment.onmicrosoft.com/48c8341e-cf28-415d-a001-b690bc6ba0b1/MemberPortal.User',
  b2cWriteScope:
    'https://ApexProductDevelopment.onmicrosoft.com/48c8341e-cf28-415d-a001-b690bc6ba0b1/MemberPortal.User',

  views: {
    ...base.views,
    historicalChart: {
      displayUnits: false,
    },
    takeMeWithYou: {
      displayChoiceOfFundForm: false,
    },
    insurance: {
      ...base.views.insurance,
      showEffectiveDate: true,
    },
    calculator: {
      superannuationCalculator: false,
      retirementProjectionCalculator: false,
      superContributionOptimiser: false,
    },
    investmentEdit: {
      showComplexComponent: true,
    },
  },
  buttonTitleTextTransform: 'SentenceCase',
  underlyingInvestmentsChartColors: [
    { key: 'International Shares', value: '#1F1A4F' },
    { key: 'Australian Shares', value: '#8598C9' },
    { key: 'Alternatives - Growth', value: '#D2DEF2' },
    { key: 'Cash', value: '#3DB4B7' },
    { key: 'Alternatives - Defensive', value: '#E0F2F3' },
    { key: 'Fixed Interest', value: '#eeeef0' },
  ],
};
